export const CustomerSidebarData = [
  {
    title: "Your Purchases",
    path: "/customer/dashboard/purchases",
  },
  {
    title: "Restringing",
    path: "/customer/dashboard/restringing",
  },
  {
    title: "Regripping",
    path: "/customer/dashboard/grip-services",
  },
  {
    title: "Your Bookings",
    path: "/customer/dashboard/booking-list",
  },
  {
    title: "Transactions",
    path: "/customer/dashboard/your-transactions",
  },
  {
    title: "Get Support",
    path: "/customer/dashboard/create-ticket",
  },
];
